import { ICartEntry, IServerOrder } from '@rbi-ctg/menu';
import { ServiceMode } from 'generated/rbi-graphql';
import { StoreProxy } from 'state/store';

import { EventNames, IAddToCartSelectionAttributes, IAnalyticsEvent, TEventCreator } from './types';

export interface IPurchaseEventPayload {
  cartEntries: ICartEntry[];
  store: StoreProxy;
  serviceMode: ServiceMode;
  serverOrder: IServerOrder;
  attrs: {
    currencyCode: string;
    fireOrderInMinutes: number;
  };
}

class IPurchaseEvent implements IAnalyticsEvent {
  eventName: EventNames.PURCHASE;
  payload: IPurchaseEventPayload;
}

export const purchaseEvent: TEventCreator<IPurchaseEvent> = (payload: IPurchaseEventPayload) => {
  return { eventName: EventNames.PURCHASE, eventType: 'purchase-complete', payload };
};

export interface IElementClickedEventPayload {
  URL: string;
  name: string;
}

class IElementClickedEvent implements IAnalyticsEvent {
  eventName: EventNames.ELEMENT_CLICKED;
  payload: IElementClickedEventPayload;
}

export const elementClickedEvent: TEventCreator<IElementClickedEvent> = (
  payload: IElementClickedEventPayload
) => {
  return { eventName: EventNames.ELEMENT_CLICKED, payload };
};

export interface IItemViewedEventPayload {
  menuData: { id: string; name: string; menuType: string };
  path: string;
}

class IItemViewedEvent implements IAnalyticsEvent {
  eventName: EventNames.ITEM_VIEWED;
  payload: IItemViewedEventPayload;
}

export const itemViewedEvent: TEventCreator<IItemViewedEvent> = (
  payload: IItemViewedEventPayload
) => {
  return { eventName: EventNames.ITEM_VIEWED, payload };
};

export interface IItemAddedEventPayload {
  cartEntry: ICartEntry;
  serviceMode: ServiceMode;
  previousCartEntries: ICartEntry[];
  selectionAttrs?: IAddToCartSelectionAttributes;
}

class IItemAddedEvent implements IAnalyticsEvent {
  eventName: EventNames.ITEM_ADDED;
  payload: IItemAddedEventPayload;
}

export const itemAddedEvent: TEventCreator<IItemAddedEvent> = (payload: IItemAddedEventPayload) => {
  return { eventName: EventNames.ITEM_ADDED, payload };
};

export interface IItemRemovedEventPayload {
  cartEntry: ICartEntry;
}

class IItemRemovedEvent implements IAnalyticsEvent {
  eventName: EventNames.ITEM_REMOVED;
  payload: IItemRemovedEventPayload;
}

export const itemRemovedEvent: TEventCreator<IItemRemovedEvent> = (
  payload: IItemRemovedEventPayload
) => {
  return { eventName: EventNames.ITEM_REMOVED, payload };
};

export interface IItemQuantityIncrementedEventPayload {
  cartEntry: ICartEntry;
}

class IItemQuantityIncrementedEvent implements IAnalyticsEvent {
  eventName: EventNames.ITEM_QUANTITY_INCREMENTED;
  payload: IItemQuantityIncrementedEventPayload;
}

export const itemQuantityIncrementedEvent: TEventCreator<IItemQuantityIncrementedEvent> = (
  payload: IItemQuantityIncrementedEventPayload
) => {
  return { eventName: EventNames.ITEM_QUANTITY_INCREMENTED, payload };
};

export interface IItemQuantityDecrementedEventPayload {
  cartEntry: ICartEntry;
}

class IItemQuantityDecrementedEvent implements IAnalyticsEvent {
  eventName: EventNames.ITEM_QUANTITY_DECREMENTED;
  payload: IItemQuantityDecrementedEventPayload;
}

export const itemQuantityDecrementedEvent: TEventCreator<IItemQuantityDecrementedEvent> = (
  payload: IItemQuantityDecrementedEventPayload
) => {
  return { eventName: EventNames.ITEM_QUANTITY_DECREMENTED, payload };
};

export type TEvents =
  | IPurchaseEvent
  | IElementClickedEvent
  | IItemViewedEvent
  | IItemAddedEvent
  | IItemRemovedEvent
  | IItemQuantityIncrementedEvent
  | IItemQuantityDecrementedEvent;
